<script>
import {isvalidPhone} from "@/utils/validate";
import {addBlackList, insertBlackList, selectUserInfoByMobile} from "@/api/activityRegistration";
import moment from "moment";

export default {
  name: 'BlacklistOperationForm',
  props: {
    operationData: {
      type: Object,
      default: {}
    },
    operationType: {
      type: String,
      default: 'add'
    }
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
       form: {
        // 手机号
        mobile: '',
        // 用户id
        userId: '',
        // 姓名/昵称
        userName: '',
        // 黑名单时间
        blackTime: '',
         // 黑名单原因
         content: '',
      },
      rules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { required: true, validator: isvalidPhone, trigger: 'blur' }
        ],
        blackTime: [
          { required: true, message: '请选择黑名单时间', trigger: 'change' }
        ],
      },
    }
  },
  created() {
    if (this.operationType === 'edit') {
      this.form ={
        // 手机号
        mobile: this.operationData.mobile,
        // 用户id
        userId:  this.operationData.userId,
        // 姓名/昵称
        userName:  this.operationData.userName,
         // 黑名单原因
        content:  this.operationData.content,
        id: this.operationData.id,
        blackTime: [moment(this.operationData.blackDateStart), moment(this.operationData.blackDateEnd)]
      }
    } else {
      this.form.blackTime = [moment(), undefined]
    }
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.addBlackList()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    /**
     * @Description：通过手机号查询用户信息
     * @Author cxd
     * @Date 2026/1/6 09:34
     */
    async searchByPhoneNumber() {
      const res = await selectUserInfoByMobile(this.form.mobile)
      const { code, data, msg } = res
      if (code === 200) {
        this.form.userName = data.nickname
        this.form.userId = data.userId
      } else {
        this.$message.error(msg)
      }
    },
    /**
     * @Description：添加黑名单
     * @Author cxd
     * @Date 2026/1/12 14:59
     */
    async addBlackList() {
      const params = {
        ...this.form,
        blackDateStart: this.form.blackTime[0],
        blackDateEnd: this.form.blackTime[1]
      }
      
      if (!this.form.userId || !this.form.userName) {
        this.$message.warn('请点击查询按钮确定要添加的用户信息！')
        return
      }
      this.$emit('addBlackList', params)
    },
    /**
     * @Description：手机号chenge事件
     * @Author cxd
     * @Date 2026/1/14 15:21
     */
    handleMobileChange() {
      this.form.userId = ''
      this.form.userName = ''
    }
  }
}
</script>

<template>
  <div>
    <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="">
        <div :style="{ paddingLeft: '100px',color: 'red' }">
          注：最晚5分钟生效
        </div>
      </a-form-model-item>
     <a-row type="flex" align="middle">
       <a-col :span="20">
         <a-form-model-item label="手机号" prop="mobile">
           <a-input :style="{ width: '330px' }" @change="handleMobileChange" :disabled="this.operationType === 'edit'" :maxLength="11" v-model.trim="form.mobile" placeholder="请输入手机号" />
         </a-form-model-item>
       </a-col>
       <a-col :span="4">
         <a-button type="primary" :disabled="this.operationType === 'edit'" @click="searchByPhoneNumber">查询</a-button>
       </a-col>
     </a-row>
      <a-form-model-item label="用户id" prop="userId">
        {{ form.userId }}
      </a-form-model-item>
      <a-form-model-item label="姓名/昵称" prop="userName">
        {{ form.userName }}
      </a-form-model-item>
      <a-form-model-item label="黑名单时间" prop="blackTime">
        <a-range-picker
            :style="{ width: '360px' }"
            show-time
            v-model="form.blackTime"
        />
      </a-form-model-item>
      <a-form-model-item label="原因" prop="content">
        <a-textarea
            :style="{ width: '360px' }"
            placeholder="请输入黑名单原因"
            :rows="3"
            v-model.trim="form.content"
            :maxLength="150"
        />
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<style scoped lang="scss">
.ant-form-item {
  margin: 0!important;
}
</style>